import React from "react"
import { Link } from "gatsby"

import Layout from "../../../components/layout"
import { FooterAlternate1 } from "../../../components/footer"
import SEO from "../../../components/seo"

const IndexPage = () => (
    <Layout>
      <SEO title="Team composition is the key to sales success!" />

                     
<nav className="share-bar">
    <ul>
        <li className="linkedin">
            <a href="https://www.linkedin.com/shareArticle?mini=true&amp;url=https%3A//salestribe.com/knowledge-centre/insights/team-composition-key-sales-success/&amp;title=Team%20composition%20is%20the%20key%20to%20sales%20success%21&amp;summary=Team%20composition%20is%20the%20key%20to%20sales%20success%21&amp;source=https%3A//salestribe.com/knowledge-centre/insights/team-composition-key-sales-success/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">LinkedIn</span>
                <span className="icon">
                    <svg width="23" height="23">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-linkedin-badge"></use>
                    </svg>
                </span>
            </a>
        </li>
        <li className="twitter">
            <a href="https://twitter.com/intent/tweet/?text=Team%20composition%20is%20the%20key%20to%20sales%20success%21&amp;url=https%3A//salestribe.com/knowledge-centre/insights/team-composition-key-sales-success/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Twitter</span>
                <span className="icon">
                    <svg width="23" height="23">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-twitter-badge"></use>
                    </svg>
                </span>
            </a>
        </li>
        <li className="googleplus">
            <a href="https://plus.google.com/share?url=https%3A//salestribe.com/knowledge-centre/insights/team-composition-key-sales-success/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Google+</span>
                <span className="icon">
                    <svg width="26" height="26">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-googleplus-badge"></use>
                    </svg>
                </span>
            </a>
        </li>
        <li className="facebook">
            <a href="https://facebook.com/sharer/sharer.php?u=https%3A//salestribe.com/knowledge-centre/insights/team-composition-key-sales-success/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Facebook</span>
                <span className="icon">
                    <svg width="22" height="22">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-facebook-badge"></use>
                    </svg>
                </span>
            </a>
        </li>
        <li className="email">
            <Link to="knowledge-centre/insights/mailto:?subject=Team%20composition%20is%20the%20key%20to%20sales%20success%21&amp;body=https%3A//salestribe.com/knowledge-centre/insights/team-composition-key-sales-success/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Email</span>
                <span className="icon">
                    <svg width="20" height="20">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-email-badge"></use>
                    </svg>
                </span>
            </Link>
        </li>
    </ul>
</nav>

<article className="article">

    

<header className="header header--article article__header" id="page-header">
    <div className="header__image" >
        <div className="header__bgimage" style={{backgroundImage: "url(../../../media/images/article-search-boat.2e16d0ba.fill-1162x655.jpg)"}}></div>
        <div className="header__video">
            <div className="embed-responsive embed-responsive-16by9"></div>
        </div>
    </div>
    <div className="header__content">
        <div className="container">
            <div className="row">
                <div className="header__inner col-md-7 col-lg-offset-1">
                    <Link to="knowledge-centre/insights/" className="header__back back-link">
                        <span className="sr-only">Back to all articles</span>
                        <i className="icon"></i>
                    </Link>
                    <div className="header__title">
                        <h3>B2B Sales</h3>
                        <h1>Team composition is the key to sales success!</h1>
                    </div>
                    <ul className="post-meta-list">
                        <li>by Graham Hawkins</li>
                        <li>8 September 2016</li>
                        <li>4 min read</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</header>


<div className="container" id="article-content">
    <div className="row">
        <div className="article__body col-sm-12 col-md-8 col-lg-offset-1 col-lg-7 wysiwyg">
            
<h3>&#39;Team Composition&#39; is the key to driving high performing sales teams.</h3>

<div className="rich-text"><p>When it comes to creating high performance teams most pundits will tell you that <em>‘clarity of objectives’</em> is always the most critical success factor. However, it is my view that <em>team composition</em> is even more important in the new customer-led era, and my rationale is based on the fact that there is no point having a crystal clear set of objectives if you don’t have the team that can execute. Of course, team performance is always a reflection of the alignment of the individual skill-sets that make up the collective, but how do you know if you have the right team when it comes to sales? How do you put your best team on the park, in the right positions, given the context (catering for conditions and competition) in order to optimise sales output? It’s never easy, but it’s absolutely impossible if you don’t apply some rigorous analysis of <em>team composition</em>.</p><p>The best sales leaders are constantly adjusting the composition, context and direction of the team in order to increase team effectiveness as measured by: organisational benchmarks for teams or the comparison with expected progress or outcomes of the team's work. On the sporting field, this bench-marking is usually very simple - you either win or lose the event, whereas in the sales profession, the sales team members actually function as <em>autonomous agents</em> – often operating as <em>lone wolfs</em> running a territory inside the broader business, and this means that sales teams are not really teams at all. However, as I have stated in previous posts, like it or not, sales people will be forced to become genuine team players as we move further into the customer-led era of sales – where sales-marketing alignment and team-based selling is fast becoming the new normal.</p><p>Sales team performance is often a <em>grey area</em> when it comes to assessments and bench-marking, and for many years I have witnessed (and managed) ineffective sales teams that limp along with the sub-standard performance due primarily to poor <em>team composition</em> - because the A-Graders continually over-achieve on their quotas by enough to cover the under-achievers. Yes, the team may still hit its numbers but that doesn’t mean that the team is optimised, and this <em>laissez</em>-<em>faire</em> approach will not cut it in the new customer-led era.</p><p>According to Harvard Business Review, <strong>“63% of all salespeople are considered to be under performers”</strong>, and this percentage is getting worse each year (certainly in my experience). The trend shines a bright light on the need for increased focus on team-based selling, collaboration and the ability of each and every business to leverage ALL of the strengths, knowledge, expertise and skills across the entire business.</p></div>
<aside className="pull-quote">
    <blockquote>
        <p>“63% of all salespeople are considered to be under performers”</p>
    </blockquote>
</aside>

<div className="rich-text"><p>Having recently undertaken a High Performance Masterclass with Elkiem Consulting (a Sydney based specialist consultancy), I spent some time thinking about the various teams (both business and sport) that I have been part of over the years, and upon reflection the most effective teams nearly always find a way to maximise individual strengths whilst simultaneously limiting or covering individual weaknesses. But of course there is more to high performance than this. To sustainably stay ahead of the competition, sales leaders must constantly review and assess team composition, which is why I find it amazing that there are still (to this day) a large majority of sales leaders that think it’s acceptable to allow low performers to continue in the business as long as the A-Graders cover their low output. What message does this send to the A-Graders (and others in the business)? How does the acceptance of low performance impact culture? We’ve all seen it, and it’s a big mistake if you are truly striving for a high performance culture.</p><p>So, what sales leaders must do is to get answers to some of the following questions:</p><p></p><ol><li>Which sales people have upside in their performance?<br/></li><li>Which sales people have likely downside in their performance?<br/></li><li>Which sales people are big talent in a small territory?<br/></li><li>Which sales people are small talent in a big territory?<br/></li><li>Who are the obvious low performers that require action?<br/></li><li>Who has high talent but needs a new role?<br/></li><li>Who has big potential but requires a bigger territory or role?<br/></li><li>Who has a high flight risk that you do not want to lose?<br/></li><li>Who is playing a strong cultural role?<br/></li><li>Who needs to play a stronger cultural role in the team?<br/></li><li>Who is having a negative cultural impact on the team?<br/></li><li>Who has headroom for growth/improvement, and who is at their limit?<br/></li></ol><p></p><p>When you have answers to all of these sorts of questions then, and only then, can you truly begin to benchmark and baseline the performance capacity of your team. More importantly, once you are armed with this data, you will be able to quickly identifying the <em>distance</em> between your best and your worst performers.....often referred to as <em><strong>‘range management'.</strong></em> The key question with <em>range management is</em> how to get your D-graders and C-graders closer towards B and A-grade performance levels?</p><p>Sounds simple right…but it rarely is. One thing is certain, unless you have the answers to the questions above, you will always be wondering why your sales output is not where it should be. Ultimately, what you should be hoping to achieve with all of this analysis is to better understand your current position and the gap between where your team is now, and where it can potentially get to with the current team composition. This sort of high level analysis will highlight the extent to which you have the right individuals, in the right roles, to facilitate optimal team performance.</p><p>So, if you are currently working as a sales leader, you must start by getting answers to the 12 questions above, and then build your team around some strong team composition parameters and guidelines. The days of <em>lone wolf </em>sales people are all but over – it’s now all about the team, and the commercial insights that can be collectively gleaned to deliver maximum value to your customers.</p></div>


        </div>
            
        <aside className="article__sidebar col-sm-12 col-md-4 col-lg-offset-1 col-lg-3">
            <div className="article__sidebar-wrap" id="article-sidebar">
                <div className="card card--profile">
                        
<div className="card__header">
    <div className="card__image">
        <img alt="Mentor Thumb Graham Hawkins" className="img-responsive" height="165" src="../../../media/images/Mentor-Thumb-Graham-Hawkins.2e16d0ba.fill-165x165.jpg" width="165"/>
    </div>
    <div className="card__title">
        <h4>Graham Hawkins</h4>
        <p>SalesTribe Mentor</p>
        <Link to="solutions/find-a-mentor/graham-hawkins" className="btn btn-link hidden-md hidden-lg">View full profile</Link>
    </div>
</div>
<div className="rich-text"><p>With more than twenty-eight years of business experience in
executive B2B sales and sales leadership roles, Graham is a highly experienced
and versatile business executive with proven strengths in strategic business
development, go-to-market planning and sales and marketing.</p><p><br/></p><p><br/></p></div>
<Link to="solutions/find-a-mentor/graham-hawkins" className="btn btn-link hidden-xs hidden-sm">View full profile</Link>

                </div>
                <nav className="social-nav">
    <h4>Share</h4>
    <ul>
        <li className="linkedin">
            <a href="https://www.linkedin.com/shareArticle?mini=true&amp;url=https%3A//salestribe.com/knowledge-centre/insights/team-composition-key-sales-success/&amp;title=Team%20composition%20is%20the%20key%20to%20sales%20success%21&amp;summary=Team%20composition%20is%20the%20key%20to%20sales%20success%21&amp;source=https%3A//salestribe.com/knowledge-centre/insights/team-composition-key-sales-success/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">LinkedIn</span>
                <span className="icon icon-linkedin"></span>
                
            </a>
        </li>
        <li className="twitter">
            <a href="https://twitter.com/intent/tweet/?text=Team%20composition%20is%20the%20key%20to%20sales%20success%21&amp;url=https%3A//salestribe.com/knowledge-centre/insights/team-composition-key-sales-success/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Twitter</span>
                <span className="icon icon-twitter"></span>
                
            </a>
        </li>
        <li className="googleplus">
            <a href="https://plus.google.com/share?url=https%3A//salestribe.com/knowledge-centre/insights/team-composition-key-sales-success/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Google+</span>
                <span className="icon icon-google-plus"></span>
                
            </a>
        </li>
        <li className="facebook">
            <a href="https://facebook.com/sharer/sharer.php?u=https%3A//salestribe.com/knowledge-centre/insights/team-composition-key-sales-success/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Facebook</span>
                <span className="icon icon-facebook-f"></span>
                
            </a>
        </li>
        <li className="email">
            <Link to="knowledge-centre/insights/mailto:?subject=Team%20composition%20is%20the%20key%20to%20sales%20success%21&amp;body=https%3A//salestribe.com/knowledge-centre/insights/team-composition-key-sales-success/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Email</span>
                <span className="icon icon-envelope"></span>
                
            </Link>
        </li>
    </ul>
</nav>

            </div>
        </aside>
            
    </div>
</div>
</article>

<div className="block block--grey related-items">
    <div className="related-items__wrap">
        <div className="container">
            <div className="row" data-tablet-slick>
                
        <article className="related-items__item col-sm-6 col-md-4">
            <Link to="knowledge-centre/insights/sales-training-complete-waste-money-and-time-part-2" className="card card--article">
                <div className="card__thumb">
                    <img alt="article-connect-coffee-chat.jpg" className="card__image" height="404" src="../../../media/images/article-connect-coffee-chat_xr8wJT.2e16d0ba.fill-716x404.jpg" width="716"/>
                    <span className="card__image-meta">5 min read</span>
                </div>
                <div className="card__inner">
                    <header>
                        <p className="card__category">B2B Sales</p>
                        <h3 className="card__title"><strong>Sales Training’ is a waste of money and time (Part 2)</strong></h3>
                    </header>
                    <p>We must stop teaching sales people how to ‘push’ buyers, and instead start training and coaching them on how to become highly specialised teachers.</p>
                    <footer><p className="card__author">Graham Hawkins</p></footer>
                </div>
            </Link>
        </article><article className="related-items__item col-sm-6 col-md-4">
            <Link to="knowledge-centre/insights/sales-training-waste-time-and-money-part-1" className="card card--article">
                <div className="card__thumb">
                    <img alt="article-connect-coffee-chat.jpg" className="card__image" height="404" src="../../../media/images/article-connect-coffee-chat_xr8wJT.2e16d0ba.fill-716x404.jpg" width="716"/>
                    <span className="card__image-meta">4 min read</span>
                </div>
                <div className="card__inner">
                    <header>
                        <p className="card__category">B2B Sales</p>
                        <h3 className="card__title"><strong>‘Sales Training’ is a waste of time and money (Part 1)</strong></h3>
                    </header>
                    <p>When you teach sales people how to ‘push’ buyers through a sales playbook you are teaching them how to destroy your business reputation.</p>
                    <footer><p className="card__author">Graham Hawkins</p></footer>
                </div>
            </Link>
        </article><article className="related-items__item col-sm-6 col-md-4">
            <Link to="knowledge-centre/insights/b2b-sales-has-changed-about-180-degrees" className="card card--article">
                <div className="card__thumb">
                    <img alt="Mentor Large Graham Hawkins" className="card__image" height="404" src="../../../media/images/Mentor-Large-Graham-Hawkins.2e16d0ba.fill-716x404.jpg" width="716"/>
                    <span className="card__image-meta">04:28</span>
                    <span className="card__icon play-icon">
                        <i className="icon"></i>
                    </span>
                </div>
                <div className="card__inner">
                    <header>
                        <p className="card__category">B2B Sales</p>
                        <h3 className="card__title"><strong>B2B Sales has changed about 180 Degrees!</strong></h3>
                    </header>
                    <p>B2B sales has now changed so dramatically that it&#39;s a &quot;profession&quot; that is barely recognisable to the role that both Tony Hughes and Graham Hawkins began about 30 years ago - respectively.</p>
                    <footer><p className="card__author">Graham Hawkins</p></footer>
                </div>
            </Link>
        </article>

            </div>
            <div className="load-more">
                <Link to="knowledge-centre/insights/" className="btn btn-link">Browse more insights</Link>
            </div>
        </div>
    </div>
</div>

      
      <FooterAlternate1 />

    </Layout>
)

export default IndexPage 